import { useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function Privacy() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div data-testid="privacy-page" className="pt-20">
      <section className="pt-[35px] pb-[35px] md:py-16 bg-[#FBFBF7] border-b border-border">
        <div className="mx-auto w-full max-w-[var(--container-max)] px-4 sm:px-6 text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-6">
              &larr; Back to Home
            </Link>
            <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">Privacy Policy</h1>
          </motion.div>
        </div>
      </section>

      <section className="pt-[35px] pb-[35px] md:py-16">
        <div className="mx-auto w-full max-w-3xl px-4 sm:px-6">
          <div className="prose prose-sm max-w-none space-y-8">
            <div>
              <h2 className="text-xl font-bold mb-3">1. Introduction</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Maple Code Academy ("we", "our", or "us") is committed to protecting the privacy of our students, parents, and website visitors. This Privacy Policy explains how we collect, use, and protect your personal information when you visit maplecodeacademy.ca or use our services.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-3">2. Information We Collect</h2>
              <p className="text-sm text-muted-foreground leading-relaxed mb-3">
                We may collect the following types of information:
              </p>
              <ul className="list-disc pl-5 space-y-1 text-sm text-muted-foreground">
                <li>Contact information (name, email address, phone number)</li>
                <li>Student information (name, age, grade level)</li>
                <li>Payment information (processed securely through third-party providers)</li>
                <li>Usage data (pages visited, time spent on site)</li>
                <li>Device and browser information</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-3">3. How We Use Your Information</h2>
              <ul className="list-disc pl-5 space-y-1 text-sm text-muted-foreground">
                <li>To provide and improve our educational services</li>
                <li>To communicate with parents about their child's progress</li>
                <li>To process registrations and payments</li>
                <li>To send relevant updates about programs and events</li>
                <li>To improve our website and user experience</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-3">4. Data Protection</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. We use industry-standard encryption for data transmission and secure storage for all personal information.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-3">5. Children's Privacy</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                We are committed to protecting the privacy of children. We do not knowingly collect personal information directly from children under 13 without parental consent. All student information is collected through parents or guardians.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-3">6. Your Rights</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                You have the right to access, correct, or delete your personal information at any time. To exercise these rights, please contact us at info@maplecodeacademy.ca.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-3">7. Contact Us</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                If you have questions about this Privacy Policy, please contact us at:<br />
                Maple Code Academy<br />
                Email: info@maplecodeacademy.ca
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
